<ng-container *ngIf="paginatedData$ | async as response; else loading">
    <table aria-label="layout to show data" class="table my-4">
        <thead class="font-15 fw-bold">
            <tr>
                <th *ngIf="enableCheckbox" scope="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="defaultCheck" (change)="toggleAllItems(response.content)" [checked]="getCheckedItems(response.content)" [indeterminate]="getIndeterminateItems(response.content)" />
                        <label class="form-check-label" for="defaultCheck"> </label>
                    </div>
                </th>
                <th scope="col" [sortable]="thItem.keyName!" (sort)="onSort($event)" *ngFor="let thItem of tableHead">
                    {{ thItem.label }}
                </th>
                <th *ngIf="actionsButton.length > 0" scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of response.content; let rowIndex = index">
                <tr class="bdr_table">
                    <td *ngIf="enableCheckbox">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="defaultCheck_{{ rowIndex }}" [checked]="isSelected(item)" (change)="toggleItem(item)" />
                            <label class="form-check-label" for="defaultCheck_{{ rowIndex }}"> </label>
                        </div>
                    </td>
                    <td *ngFor="let thItem of tableHead; let last = last" class="nv-table-td">
                        <span class="d-block w-100 text-truncate">{{ item[thItem.keyName!] | formatter : { type: thItem.pipe?.type, format: thItem.pipe?.format } }}</span>
                    </td>
                    <td *ngIf="actionsButton.length > 0">
                        <div class="d-inline-flex">
                            <ng-container *ngFor="let action of actionsButton | slice : 0 : maxInlineAction">
                                <button
                                    *ngIf="action.action === 'accordion'; else classicAction"
                                    data-bs-toggle="collapse"
                                    attr.data-bs-target="#accordion_{{ rowIndex }}"
                                    aria-expanded="false"
                                    attr.aria-controls="accordion_{{ rowIndex }}"
                                    [attr.class]="action.class ? action.class : action.getClass(item)"
                                    [placement]="action.placement || 'auto'"
                                    [ngbTooltip]="action.ngbTooltip || action.name"
                                    (click)="getAccordionMessage(item)"
                                >
                                    <fa-icon [icon]="action.loading && item.loading ? ['fal', 'spinner'] : action.icon" [spin]="item.loading" class="font-20"></fa-icon>
                                </button>
                                <ng-template #classicAction>
                                    <button *ngIf="action.hidden?.(item) !== true" [attr.class]="action.class ? action.class : action.getClass(item)" (click)="eventAction({action, item})" [placement]="action.placement || 'auto'" [ngbTooltip]="action.ngbTooltip || action.name">
                                        <fa-icon [icon]="action.icon" class="font-20"></fa-icon>
                                    </button>
                                </ng-template>
                            </ng-container>
                            <div class="d-inline-block" ngbDropdown *ngIf="actionsButton.length > maxInlineAction" container="body">
                                <button id="dropdownActions_{{ rowIndex }}" ngbDropdownToggle class="edit-btn align-items-top">
                                    <fa-icon [icon]="['fas', 'ellipsis']" [styles]="{'vertical-align': '-0.15em'}"></fa-icon>
                                </button>
                                <div ngbDropdownMenu attr.aria-labelledby="dropdownActions_{{ rowIndex }}" class="dropdown-content mx-3">
                                    <div *ngFor="let action of actionsButton | slice : maxInlineAction : actionsButton.length; let last = last">
                                        <ng-container *ngIf="action.hidden?.(item) !== true">
                                            <button
                                                *ngIf="action.action === 'accordion'; else classicAction"
                                                ngbDropdownItem
                                                data-bs-toggle="collapse"
                                                attr.data-bs-target="#accordion_{{ rowIndex }}"
                                                aria-expanded="false"
                                                attr.aria-controls="accordion_{{ rowIndex }}"
                                                [attr.class]="action.class ? action.class : action.getClass(item)"
                                                (click)="eventAction({action, item})"
                                            >
                                                <fa-icon class="px-3" [icon]="action.icon"></fa-icon>
                                                {{ action.name }}
                                            </button>
                                            <ng-template #classicAction>
                                                <button ngbDropdownItem [attr.class]="action.class ? action.class : action.getClass(item)" (click)="eventAction({action, item})">
                                                    <fa-icon class="px-3" [icon]="action.icon"></fa-icon>
                                                    {{ action.name }}
                                                </button>
                                            </ng-template>
                                            <hr *ngIf="!last" />
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr id="accordion_{{ rowIndex }}" class="accordion-collapse collapse" data-bs-parent="#accordion">
                    <td class="nv-td-accordion {{ item['accordionKO'] ? 'alert alert-danger' : '' }}" colspan="100%">
                        <div class="accordion-body">{{ item['accordionMessage'] }}</div>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="response.empty">
                <tr class="nv-no-result">
                    <td colspan="100%" class="text-center">
                        <p class="mt-3">Nessun risultato trovato</p>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>

    <div class="row d-flex align-items-center">
        <div class="col-4"></div>
        <div class="col-4 d-flex text-center justify-content-center">
            <app-pagination [totalElements]="response.totalElements" [pageSize]="response.pageable.pageSize" [pageNumber]="response.pageable.pageNumber" (onPageChanged)="onPageChange($event)"> </app-pagination>
        </div>
        <div class="col-4 d-flex justify-content-end">
            <button class="btn btn-primary" [ngClass]="{ 'd-none': selectedItems.length === 0 }" (click)="onOpenModal(selectedItems)">Sposta elementi selezionati</button>
        </div>
    </div>
</ng-container> 

<ng-template #loading>
    <app-loading [show]="true"></app-loading>
</ng-template>
